<template>
  <fragment>
    <b-loading v-if="loading" active :is-full-page="false" />
    <mc-error-layout
      v-else-if="error"
      :message="`Failed to load list: ${error.message}`"
      :retry-fn="getPage"
    />
    <div v-else>
      <slot :items="resourceList" />
      <mc-pagination v-if="!isSearch" :resource-state="resourceState" />
    </div>
  </fragment>
</template>

<script>
export default {
  props: {
    resourceState: {
      type: String,
      required: true
    },
    hasSearch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    resourceStateObject() {
      return this.$store.state[this.resourceState];
    },
    isSearch() {
      return (
        this.hasSearch && this.$store.state[this.resourceState].searchQuery
      );
    },
    resourceList() {
      return this.$store.state[this.resourceState][
        this.isSearch ? 'searchResults' : 'list'
      ];
    },
    loading() {
      return this.resourceStateObject[
        this.isSearch ? 'searching' : 'loadingPage'
      ];
    },
    error() {
      return this.resourceStateObject[
        this.isSearch ? 'searchError' : 'pageError'
      ];
    }
  },
  mounted() {
    this.getPage();
  },
  methods: {
    getPage: function() {
      this.$store.dispatch(`${this.resourceState}/get`);
    }
  }
};
</script>
